import { useContext } from "react";
import { Trans } from "react-i18next";
import { Context } from "../ContextProvider";
import { LANGUAGE } from "../type";

const Footer = () => {
  const { language } = useContext(Context);

  return (
    <footer>
      <div className="bg-allsafe-dark-grey px-3.5 pt-16 pb-6 lg:pt-20">
        <div className="max-w-screen-2xl mx-auto">
          <img
            src="https://allsafe.canto.de/direct/image/blgfnl7gvd2u9dtobuj15laf0e/1ejhWPQb3sgfP1YkRpkGiVpNvdU/original?content-type=image%2Fsvg%2Bxml&name=allsafe_logo_claim_Sicherheit_neg.svg"
            alt="logo"
            className="w-[169.594px] h-[72px]"

          />
          <hr className=" text-allsafe-grey opacity-75 my-6" />
          <div className="flex items-center justify-between gap-x-8 gap-y-10 flex-wrap md:gap-y-0">
            <ul className="p-0 m-0 flex flex-wrap gap-x-4 max-w-max">
              <li>
                <a
                  className="text-gray-200 underline decoration-text-gray-200 text-base leading-6 font-inter-light decoration-2"
                  href={
                    language === LANGUAGE.DE
                      ? "https://www.allsafe24.com/datenschutzerklaerung"
                      : "https://www.allsafe24.com/en/datenschutzerklaerung"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <Trans i18nKey="privacyStatement">
                    Datenschutzerklärung
                  </Trans>
                </a>
              </li>
              <li>
                <a
                  className="text-gray-200 underline decoration-text-gray-200 text-base leading-6 font-inter-light decoration-2"
                  href={
                    language === LANGUAGE.DE
                      ? "https://www.allsafe24.com/datenschutzerklaerung#cookie-settings"
                      : "https://www.allsafe24.com/en/datenschutzerklaerung#cookie-settings"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <Trans i18nKey="cookieSettings">Cookie-Einstellungen</Trans>
                </a>
              </li>
              <li>
                <a
                  className="text-gray-200 underline decoration-text-gray-200 text-base leading-6 font-inter-light decoration-2"
                  href={
                    language === LANGUAGE.DE
                      ? "https://www.allsafe24.com/impressum"
                      : "https://www.allsafe24.com/en/impressum"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <Trans i18nKey="imprint">Impressum</Trans>
                </a>
              </li>
              <li>
                <a
                  className="text-gray-200 underline decoration-text-gray-200 text-base leading-6 font-inter-light decoration-2"
                  href={
                    language === LANGUAGE.DE
                      ? "https://www.allsafe24.com/avb"
                      : "https://www.allsafe24.com/en/avb"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  AVB
                </a>
              </li>
            </ul>
            <p className="text-allsafe-grey-500 text-base leading-6 font-inter-light opacity-75">
              © 2023 allsafe GmbH & Co. KG
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
